var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImpactAnalysis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 41,
    r: 40.5,
    stroke: "#FB9B0B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81 41C81 63.0914 63.0914 81 41 81C18.9086 81 1 63.0914 1 41C1 18.9086 18.9086 1 41 1C63.0914 1 81 18.9086 81 41ZM6.2 41C6.2 60.2195 21.7805 75.8 41 75.8C60.2195 75.8 75.8 60.2195 75.8 41C75.8 21.7805 60.2195 6.2 41 6.2C21.7805 6.2 6.2 21.7805 6.2 41Z",
    fill: "#FB9B0B",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6667 61L41.7576 21L60.8485 61H22.6667ZM57.9667 59.1818L41.7576 25.2218L25.5485 59.1818H57.9667ZM40.8485 31.9091H42.6667V48.2727H40.8485V31.9091ZM42.6667 55.5455V51.9091H40.8485V55.5455H42.6667Z",
    fill: "#141413"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpactAnalysis);
export default __webpack_public_path__ + "static/media/impact_analysis.85be5a87eb9d8e9e54e6842d6ec94248.svg";
export { ForwardRef as ReactComponent };